export default __webpack_public_path__ + "static/media/gallery36.fbdf8306.webp";